module.exports = __webpack_public_path__ + "img/Support-skill-520.5b4aa1ef.png";